import React from "react";
import { useTiara } from "src/hooks";
import { FullHeaderPage } from "src/ccl/templates";
import { NotFoundError } from "src/components/errors";
import { RebrandFooter } from "src/ccl/blocks/footer/RebrandFooter";

interface NotFoundProps {
  message?: React.ReactNode;
}

const NotFound = ({ message }: NotFoundProps) => {
  useTiara({ title: "Not found" });

  return (
    <FullHeaderPage FooterComponent={RebrandFooter}>
      <NotFoundError message={message} />
    </FullHeaderPage>
  );
};

// For code splitting
export default NotFound; // eslint-disable-line
